module.exports = __webpack_public_path__ + "static/mirage-world-nearby-94d73ae14f85c45ba0658baf24a478df.png";